import Nav from '../components/Nav';
import '../styles/About.css'
import {
  motion,
} from "framer-motion";
import {
  useState
} from 'react';
import { TypeAnimation } from 'react-type-animation';

const Comment = (paragraphState) => {
    switch (paragraphState) {
      case 1:
        return ( "//click anywhere to continue" );
      case 2:
        return ( "//one more times" );
      case 3:
        return ( "//two of three" );
      case 4:
        return ( "//last one" );
      default:
        return ( "//Click anywhere to continue" );
    }
}

const Paragraph = ({ paragraphState, typing, setTyping }) => {

  const renderParagraph = () => {
    switch (paragraphState) {
      case 1:
        return (
          <motion.p className={"Paragraph About-1"}>
            {typing ? (
              <TypeAnimation
                sequence={[
                  `I've been doing frontend development for 1.5 years and at the moment I have mastered many technologies, such as JavaScript, React, Vue,TypeScript and many others.`,
                  750,
                  () => {
                    setTyping(false);
                  },
                ]}
                speed={99}
                cursor={true}
                className="TypeAnimation"
              />
            ) : (
              <motion.span animate={{ scale: typing ? 1.1 : 1 }}>
                I've been doing frontend development for 1.5 years and at the moment I have mastered many technologies, such as JavaScript, React, Vue,TypeScript and many others.
              </motion.span>
            )}
          </motion.p>
        );
      case 3:
        return (
          <motion.p className={"Paragraph About-3"}>
            {typing ? (
              <TypeAnimation
                sequence={[
                  `Now I am actively looking for a job and if you are interested in my site, you can contact me on social networks or send a letter to an e-mail.`,
                  750,
                  () => {
                    setTyping(false);
                  },
                ]}
                speed={99}
                cursor={true}
                className="TypeAnimation"
              />
            ) : ( 
              <motion.span animate={{ scale: typing ? 1.1 : 1 }}>
              Now I am actively looking for a <b>job</b> and if you are interested in my site, you can contact me on social networks or send a letter to an e-mail.
              </motion.span>
            )}
          </motion.p>
        );
      case 2:
        return (
          <motion.p className={"Paragraph About-4"}>
            {typing ? (
              <TypeAnimation
                sequence={[
                  `This portfolio website is a testament to my skills and hard work. Thank you for visiting my website, and I hope you enjoy browsing through my projects.`,
                  750,
                  () => {
                    setTyping(false);
                  },
                ]}
                speed={99}
                cursor={true}
                className="TypeAnimation"
              />
            ) : ( 
              <motion.span animate={{ scale: typing ? 1.1 : 1 }}>
                This portfolio website is a testament to my <b>skills</b> and hard work. Thank you for visiting my website,
                and I hope you enjoy browsing through my <b>projects</b>.
              </motion.span>
            )}
          </motion.p>
        );
      default:
        return null;
    }
  };

  return <>{renderParagraph()}</>
}

function About() {

  const [paragraphState, setParagraphState] = useState(1);
  const [typing, setTyping] = useState(true);



  return(
      <div>
        <Nav color="var(--green)"/>
        <div className="About" onClick={()=>{
          if (paragraphState === 4 && typing === false) {
            setParagraphState(1);
            setTyping(true);
          } else if ( paragraphState < 4 && typing === false){
            setParagraphState(paragraphState + 1);
            setTyping(true);
          }
        }}>
            <p className="Comment">
              {typing ? null : 
              <TypeAnimation 
                sequence={
                  [Comment(paragraphState)]
                }
                speed={80}
                />
                }
              {
                paragraphState === 4 ?
                <TypeAnimation 
                sequence={
                  ["//check these out"]
                }
                speed={80}
                /> : null
              }
            </p>
            <Paragraph paragraphState={paragraphState} typing={typing} setTyping={setTyping}/>
            <motion.div
              className="Hyperlinks"
              initial={{opacity: 0}}
              animate={{
                opacity: paragraphState === 4 ? 1 : 0,
                }}
              transition={{
                duration: 0.75,
              }}>
                <motion.a
                  animation={{
                    y: paragraphState === 4 ? 0 : 250,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                  whileHover={{
                    letterSpacing: "0.25rem",
                    color: "var(--red)",
                  }}
                  style={{
                    pointerEvents: paragraphState === 4 ? "all" : "none",
                  }}
                  href="/#/skills">
                    skills
                  </motion.a>
                <motion.a
                  animation={{
                    y: paragraphState === 4 ? 0 : 250,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                  whileHover={{
                    letterSpacing: "0.25rem",
                    color: "var(--purple)",
                  }}
                  style={{
                    pointerEvents: paragraphState === 4 ? "all" : "none",
                  }}
                  href="/#/projects">
                    projects
                  </motion.a>
                
                <motion.a
                  animation={{
                    y: paragraphState === 4 ? 0 : 250,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                  whileHover={{
                    letterSpacing: "0.25rem",
                    color: "var(--green)",
                  }}
                  style={{
                    pointerEvents: paragraphState === 4 ? "all" : "none",
                  }}
                  onClick={()=>{setParagraphState(1);setTyping(true)}}>
                    <b>read again</b>
                  </motion.a>
            </motion.div>
        </div>
      </div>
    )
}

export default About;